import React, { useState } from 'react'

import Container from '../../../components/Container'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import t from '../../../translations'
import { Typography } from '@material-ui/core'

const styles = {
  effects: {
    margin: 0,
    paddingLeft: '1.25rem',
  },
}

// „OK” wysyła ankietę, więc najpierw okno z opisem skutku; „Anuluj”, Esc i kliknięcie obok niczego nie wysyłają
// (decyzja właściciela 2026-09-24). Przycisk obrysowany, żeby nie mylił się z przyciskiem wysyłania na dole strony.
const OkButton = ({ onConfirm }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const closeDialog = () => setIsDialogOpen(false)
  const confirm = () => {
    setIsDialogOpen(false)
    onConfirm()
  }

  return (
    <Container>
      <Typography
        paragraph={true}
        variant={'body1'}
      >
        {t.pollView.okBtnCaption}
      </Typography>
      <Button
        variant={'outlined'}
        color={'primary'}
        onClick={() => setIsDialogOpen(true)}
        fullWidth={true}
      >
        {t.pollView.okBtn}
      </Button>
      <Dialog
        open={isDialogOpen}
        onClose={closeDialog}
        aria-labelledby={'ok-dialog-tytul'}
        aria-describedby={'ok-dialog-opis'}
      >
        <DialogTitle id={'ok-dialog-tytul'}>
          {t.pollView.okDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id={'ok-dialog-opis'} component={'div'}>
            <ul style={styles.effects}>
              <li>{t.pollView.okDialogRange}</li>
              <li>{t.pollView.okDialogText} „{t.pollView.okBtnTxtAnswer}”.</li>
              <li>{t.pollView.okDialogLowMark}</li>
              <li>{t.pollView.okDialogKeep}</li>
              <li>{t.pollView.okDialogFinal}</li>
            </ul>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog} color={'primary'} autoFocus={true}>
            {t.pollView.okDialogCancel}
          </Button>
          <Button onClick={confirm} color={'primary'} variant={'contained'}>
            {t.pollView.okDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}

export default OkButton
